export const generateIndexPermission = (indexPermissions) => {
  let permissionList = [];

  Object.keys(indexPermissions).forEach((rlm) => {
    const keysplit = rlm.split("_");

    permissionList.push({
      hmg_id: keysplit[1],
      index_id: keysplit[2],
      value: indexPermissions[rlm],
    });
  });
  return permissionList;
};

export const setIndexPermissions = (key, val, indexPermissions) => {
  const indexPermissionsArray = { ...indexPermissions };
  if (indexPermissionsArray[key] !== undefined) {
    indexPermissionsArray[key] = val;
  }
  return indexPermissionsArray
};

export const setIndexEnabled = (value, indexPermissions) => {
  const permissions = { ...indexPermissions };
  const indexPermissionData = {
    isEnabled: value === true,
    indexPermissions: permissions,
  };
  return indexPermissionData;
};
